import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { retrieveContentJSON } from '../../utils/content-fragments';
import styles from './LegalReviewNumber.css';

const LegalReviewNumber = ({ lrnCode, styleFlags }) => {
    const [lrn, setLrn] = useState(null);

    const { grey, indent } = styleFlags || {};

    const findLrn = (lrnData) => {
        const pageLrn = lrnData.find((lrnObj) =>
            lrnObj.tickers.includes(lrnCode)
        );
        return pageLrn ? pageLrn.lrn : null;
    };

    useEffect(() => {
        const runLrnRetrieval = async () => {
            const contentJSON = await retrieveContentJSON(
                '/graphql/execute.json/iinvestor/getJSONModel%3Bpath=/content/dam/iinvestor/fund-research/fund-lrns'
            );

            if (!contentJSON) return;

            const { lrns } = contentJSON;

            if (lrns && lrns.length) {
                setLrn(findLrn(lrns));
            }
        };

        runLrnRetrieval();
    }, []);

    return !lrn ? null : (
        <div
            className={cn('lrn-wrapper', {
                grey,
                indent
            })}
        >
            <span>{lrn}</span>
            <style jsx>{styles}</style>
        </div>
    );
};

export default LegalReviewNumber;
